import { useQuery } from '@tanstack/react-query';
import { fetchTesterPresence } from './api';

/**
 * Polls `/discord/activity/presence` — the same global active-tester roster
 * `runhuman.com/tester` renders, served behind the Discord OAuth guard.
 *
 * Cadence mirrors the web Tester Portal's `useTesterPresence`: 30s refetch,
 * with React Query pausing while the document is hidden so the iframe stops
 * polling when the user switches away. Discord channel membership is no
 * longer involved — every active tester is surfaced regardless of voice
 * state or whether they've linked their Discord account.
 */
export function useTesterPresence(accessToken: string | undefined) {
  return useQuery({
    queryKey: ['discord-activity-presence'],
    queryFn: () => fetchTesterPresence(accessToken!),
    enabled: Boolean(accessToken),
    refetchInterval: 30_000,
    staleTime: 5_000,
    retry: 1,
  });
}
